import React from 'react';
import { useTranslation } from 'react-i18next';
import { buildUrl, VALID_URLS } from 'Douleutaras/utilities/url-builder';
import rebookIcon from 'Assets/layout/profile/attributes/rebook.svg';

import { CtaRebookNotReviewedProps } from './types';
import { CtaSectionContent } from './CtaSectionContent';

export const CtaRebookNotReviewed: React.FC<CtaRebookNotReviewedProps> = ({ name, jobId, bidId, onPrimaryClicked }) => {
  const { t } = useTranslation();

  return (
    <CtaSectionContent icon={rebookIcon}
                       header={t('T.PROS-PROFILE.CTA.START-YOUR-NEW-JOB')}
                       description={t('T.PROS-PROFILE.CTA.DO-YOU-WANT-TO-REBOOK {{name}}', { name })}
                       primaryTitle={t('T.PROS-PROFILE.CTA.REBOOK {{name}}', { name })}
                       primaryAction={() => typeof onPrimaryClicked === 'function' && onPrimaryClicked()}
                       secondaryTitle={t('T.PROS-PROFILE.CTA.REVIEW {{name}}', { name })}
                       secondaryAction={() => window.open(
                         Boolean(jobId)
                           ? buildUrl(VALID_URLS.CLIENT_REVIEW_BID, jobId, bidId)
                           // TODO: deprecate this url after API response would be updated
                           : `/dashboard/employer/review/bid/${bidId}`,
                         '_blank'
                       )}
    />
  );
};
